<template>
    <div class="classifyContainer">
        <!-- 搜索框 -->
        <div class="goSearch" @click="goSearch">
            <input type="text" placeholder="请输入">
        </div>
        <div class="tab">
            <div :class="[ isJxOrClass == 'jx' ? 'act' : '' ]" @click="tabJx">
                <p>精选</p>
                <div></div>
            </div>
            <div :class="[ isJxOrClass == 'class' ? 'act' : '' ]" @click="tabClass">
                <p>分类</p>
                <div></div>
            </div>
        </div>
        <transition enter-active-class="animated slideInLeft" leave-active-class="animated slideOutLeft">
            <div class="jx" v-if="isJxOrClass == 'jx'">
                <ul ref="jxClassH">
                    <li v-for="(item, index) of jxClassList" :key="index" :class="[item.classTypeId==jxActClassTypeId ? 'act' : '']" @click="getBookList(item.classTypeId)" ref="jxClassItemH">
                        <div>
                            <p>{{item.name}}</p>
                            <!-- <span>{{item.bookSum}}册</span> -->
                        </div>
                    </li>
                </ul>
                <div ref="jxListH" @scroll.passive="onScroll">
                    <ol ref="jxScrollH">
                        <li v-for="(item, index) of jxBookList" :key="index" @click="goBookInfo(item.bookId)">
                            <img :src="item.cover" alt="">
                            <p>{{ item.bookName }}</p>
                        </li>
                    </ol>
                </div>
            </div>
        </transition>
        <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
            <div class="classList" v-if="isJxOrClass == 'class'">
                <ul>
                    <li v-for="(item, index) of classList" :key="index" :class="[item.classTypeId==classActClassTypeId ? 'act' : '']" @click="getHaveOrNoChildrenToPid(item.classTypeId)">
                        <div>
                            <p>{{item.name}}</p>
                            <!-- <span>{{item.bookSum}}册</span> -->
                        </div>
                    </li>
                </ul>
                <div ref="classListH">
                    <ul>
                        <li v-for="(item, index) of noSubset" :key="index" @click="goClassBookList(item)">
                            <img :src="item.cover" alt="">
                            <p>{{ item.name }}</p>
                        </li>
                    </ul>
                    <div v-for="(item, index) of haveSubset" :key="index">
                        <h2>{{ item.name }}</h2>
                        <ol>
                            <li v-for="(childrenItem, childrenIndex) of item.childrenList" :key="childrenIndex"  @click="goClassBookList(childrenItem)">
                                <img :src="childrenItem.cover" alt="">
                                <p>{{ childrenItem.name }}</p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    // name: "标签,版块"
    data() {
        return {
            jxClassList: [],
            jxBookList: [],
            jxClassH_scrollTop: 0,
            jxListH_scrollTop: 0,
            jxScrollH: null,
            isMoreList: true,
            isJxOrClass: 'jx',
            jxActClassTypeId: null,
            jxClassId: null,
            pageNum: 1,
            pages: 0,
            classList: [],
            haveSubset: [],
            noSubset: [],
            classActClassTypeId: 0,
        }
    },
    beforeRouteEnter(to, from, next) {
        let that = this;
        if(from.name  == 'bookInfo' || from.name  == 'classBookList'){

            to.meta.isBack = true;

        }
        next();
    },
    created() {
        var that = this;
        that.jxActClassTypeId = that.$route.query.id ? that.$route.query.id : null;
        that.getChoiceByPid();
    },
    activated() {
        let that = this;
        if(!that.$route.meta.isBack) {
            that.pageNum = 1;
            that.isJxOrClass = 'jx';
            that.jxActClassTypeId = that.$route.query.id ? that.$route.query.id : null;
            that.getChoiceByPid();
        }else{
            if( that.$refs.jxClassH ) {
                that.$refs.jxClassH.scrollTop = that.jxClassH_scrollTop;
                that.$refs.jxListH.scrollTop = that.jxListH_scrollTop;
            }
            
            that.$route.meta.isBack=false;
        }
        
    },
    methods:{
        getChoiceByPid() {
            // 获取精选分类
            var that = this;
            var data = {
                classTypeId: localStorage.getItem("classTypeId")
            }
            that.allApi.getChoiceByPid(data).then(function(resource) {
                // console.log(resource.data)
                that.jxClassList = resource.data.data.list;
                that.$nextTick(()=>{
                    
                    if( that.jxActClassTypeId ) {
                        that.getBookListByType(that.jxActClassTypeId);
                    }else{
                        that.getBookListByType(resource.data.data.list[0].classTypeId);
                    }

                    for( var i=0,len=that.jxClassList.length;i<len;i++ ){
                        if( that.jxActClassTypeId == that.jxClassList[i].classTypeId ){
                            that.$refs.jxClassH.scrollTop = that.$refs.jxClassItemH[i].offsetHeight * i;
                            that.jxClassH_scrollTop = that.$refs.jxClassItemH[i].offsetHeight * i;
                        }
                    }
                    
                })
            });
        },
        getBookList(id) {
            var that = this;
            that.pageNum = 1;
            that.$refs.jxListH.scrollTop = 0;
            that.getBookListByType(id);
        },
        getBookListByType(id){
            // 获取精选分类书籍列表
            var that = this;
            that.jxActClassTypeId = (id ? id : that.jxActClassTypeId);
            var data = {
                page: {
                    pageNum: that.pageNum,
                    pageSize: 20,
                },
                ticket: localStorage.getItem("ticket"),
                classTypeId: that.jxActClassTypeId
            }
            that.allApi.getBookListByType(data).then((resource) => {
                // console.log(resource.data);
                if( that.pageNum == 1 ) {
                    that.jxBookList = resource.data.data.list;
                    that.pages = resource.data.data.totalPage;
                }else{
                    that.jxBookList = that.jxBookList.concat(resource.data.data.list);
                }

                that.$nextTick(()=>{
                    that.isMoreList = true;
                    that.jxScrollH = that.$refs.jxScrollH.offsetHeight;
                })
            })
        },
        onScroll() {
            var that = this;
            var boxH = that.$refs.jxListH.offsetHeight;
            var boxTop = that.$refs.jxListH.scrollTop;
            that.jxListH_scrollTop = boxTop;
            if (that.isMoreList && that.jxScrollH - boxH - boxTop < 100) {
                if( that.pageNum + 1 > that.pages ){
                    that.pageNum = that.pages;
                    return false;
                }else{
                    that.isMoreList = false;
                    that.pageNum ++;
                    that.getBookListByType();
                }
            }
        },
        getClassL(){
            // 分类
            var that = this;
            var data = {
                classTypePid: localStorage.getItem("classTypeId")
            }
            that.allApi.getClassTypeByPid(data).then((resource)=>{
                // console.log(resource.data)
                that.classList = resource.data.data;
                that.$nextTick(()=>{
                    that.getHaveOrNoChildrenToPid(resource.data.data[0].classTypeId);
                })
            })
        },
        getHaveOrNoChildrenToPid(id){
            var that = this;
            that.$refs.classListH.scrollTop = 0;
            that.classActClassTypeId = id;
            var data = {
                classTypePid: id
            }
            that.allApi.getHaveOrNoChildrenToPid(data).then((resource)=>{
                // console.log(resource.data)
                that.haveSubset = resource.data.data.haveSubset;
                that.noSubset = resource.data.data.noSubset;
            })
        },
        tabJx(){
            var that = this;
            that.isJxOrClass = 'jx';
            that.jxActClassTypeId = null;
            that.getChoiceByPid();
        },
        tabClass(){
            var that = this;
            that.isJxOrClass = 'class';
            that.getClassL()
        },
        goClassBookList(item) {
            var that = this;
            // console.log(item)
            that.$router.push({
                path: "/classBookList",
                query: {
                    classTypeId: item.classTypeId,
                    name: item.name,
                    type: 'class'
                }
            });
        },
        goBookInfo(id) {
            var that = this;
            that.$router.push({
                path: `/bookInfo/${id}`
            });
        },
        goSearch() {
            this.$router.push("/search");
        },
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.classifyContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: rem(114px);
    top: 0;
    padding-top: rem(24px);
    background: #fff;
    .goSearch{
        width: 100%;
        >input{
            display: block;
            width: rem(670px);
            height: rem(60px);
            margin: 0 auto rem(45px);
            line-height: rem(60px);
            padding: 0 rem(24px);
            color: #666;
            text-indent: rem(40px);
            background: url('../assets/imgs/index/search.png') rem(24px) center / rem(30px) rem(30px) no-repeat, #EAE9E9;
            border: 0;
            border-radius: rem(30px);
            outline: none;
            font-size: rem(24px);
        }
    }
    .tab{
        display: flex;
        justify-content: center;
        margin-bottom: rem(60px);
        >div{
            margin: 0 rem(26px);
            height: rem(64px);
            position: relative;
            >p{
                line-height: rem(50px);
                font-size: rem(36px);
                color: #111;
            }
            >div{
                border-bottom: rem(5px) solid #fff;
                position: absolute;
                width: rem(40px);
                height: 0;
                left: 50%;
                bottom: 0;
                margin-left: rem(-20px);
            }
            &.act{
                >p{
                    color: #007AFF;
                }
                >div{
                    border-bottom: rem(5px) solid #007AFF;
                }
            }
        }
    }
    .jx{
        position: absolute;
        left: 0;
        bottom: 0;
        top: rem(253px);
        right: 0;
        display: flex;
        >ul{
            width: rem(186px);
            height: 100%;
            border-right: .5px solid #E5E5E5;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            text-align: center;
            li{
                padding-bottom: rem(60px);
                position: relative;
                &::before{
                    content: "";
                    height: rem(45px);
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: rem(5px);
                    background: #fff;
                }
                &.act{
                    &::before{
                        content: "";
                        height: rem(45px);
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: rem(5px);
                        background: #007AFF;
                    }
                    >div{
                        >p{
                            color: #333;
                        }
                    }
                }
                >div{
                    // width: rem(130px);
                    // margin: 0 auto;
                    >p{
                        line-height: rem(45px);
                        font-size: rem(32px);
                        color: #999;
                    }
                    >span{
                        line-height: rem(30px);
                        font-size: rem(22px);
                        color: #999;
                    }
                }
            }
        }
        >div{
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
             flex: 1;
            >ol{
                >li{
                    float: left;
                    margin: 0 rem(21px) rem(40px);
                    width: rem(145px);
                    >img{
                        display: block;
                        width: 100%;
                        height: rem(145px);
                        margin-bottom: rem(6px);
                        border-radius: rem(6px);
                    }
                    >p{
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        font-size: rem(22px);
                        line-height: rem(30px);
                        color: #999;
                        text-align: center;
                    }
                }
                &::after{
                    content: "";
                    width: 0;
                    height: 0;
                    display: block;
                    clear: both;
                    overflow: hidden;
                }
            }
        }
    }
    .classList{
        position: absolute;
        left: 0;
        bottom: 0;
        top: rem(253px);
        right: 0;
        display: flex;
        >ul{
            width: rem(186px);
            height: 100%;
            border-right: .5px solid #E5E5E5;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            text-align: center;
            li{
                padding-bottom: rem(60px);
                position: relative;
                &::before{
                    content: "";
                    height: rem(45px);
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: rem(5px);
                    background: #fff;
                }
                &.act{
                    &::before{
                        content: "";
                        height: rem(45px);
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: rem(5px);
                        background: #007AFF;
                    }
                    >div{
                        >p{
                            color: #333;
                        }
                    }
                }
                >div{
                    // width: rem(130px);
                    // margin: 0 auto;
                    >p{
                        line-height: rem(45px);
                        font-size: rem(32px);
                        color: #999;
                    }
                    >span{
                        line-height: rem(30px);
                        font-size: rem(22px);
                        color: #999;
                    }
                }
            }
        }
        >div{
            flex: 1;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            h2{
                font-size: rem(24px);
                color: #333;
                line-height: rem(34px);
                margin-top: rem(20px);
                margin-bottom: rem(30px);
                padding: 0 rem(24px);
            }
            ul,
            ol{
                overflow: hidden;
            }
            li{
                float: left;
                margin: 0 rem(21px) rem(40px);
                width: rem(145px);
                >img{
                    display: block;
                    width: 100%;
                    height: rem(145px);
                    margin-bottom: rem(6px);
                    border-radius: rem(6px);
                }
                >p{
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    font-size: rem(22px);
                    line-height: rem(30px);
                    color: #999;
                    text-align: center;
                }
            }
        }
    }
    // .classify{
    //     padding: rem(30px) 0 rem(20px);
    //     .lately{
    //         overflow: hidden;
    //         >p{
    //             float: left;
    //             line-height: rem(60px);
    //             margin-bottom: rem(30px);
    //             padding-left: rem(30px);
    //             font-size: rem(28px);
    //             color: #a4a4b7;
    //             margin-right: rem(60px);
    //         }
    //         >div{
    //             width: 20%;
    //             font-size: rem(28px);
    //             line-height: rem(58px);
    //             text-align: center;
    //             background: #fff;
    //             color: #333;
    //             float: left;
    //             border-radius: rem(30px);
    //             margin-right: rem(10px);
    //             overflow: hidden;
    //             text-overflow: ellipsis;
    //             white-space: nowrap;
    //         }
    //     }
    //     .tag{
    //         overflow: hidden;
    //         height: rem(90px);
    //         line-height: rem(90px);
    //         background: #fff;
    //         font-size: rem(28px);
    //         margin-bottom: rem(20px);
    //         &:last-of-type{
    //             margin-bottom: 0;
    //         }
    //         >div{
    //             float: left;
    //             overflow: hidden;
    //             padding-left: rem(30px);
    //             text-overflow: ellipsis;
    //             white-space: nowrap;
    //             width: 25%;
    //             border-right: 2px solid #f3f4f5;
    //             >img{
    //                 float: left;
    //                 width: rem(34px);
    //                 height: rem(34px);
    //                 margin-top: rem(28px);
    //                 margin-right: rem(12px);
    //             }
    //         }
    //         >ul{
    //             overflow: hidden;
    //             float: left;
    //             width: 75%;
    //             >li{
    //                 float: left;
    //                 width: 33.33%;
    //                 text-align: center;
    //                 border-right: 2px solid #f3f4f5;
    //                 text-overflow: ellipsis;
    //                 white-space: nowrap;
    //                 overflow: hidden;
    //                 &:last-child{
    //                     border-right: 0;
    //                 }
    //             }
    //         }
    //     }
    //     .plate{
    //         .classHead{
    //             line-height: rem(80px);
    //             color: #333;
    //             font-size: rem(28px);
    //             padding: 0 rem(30px);
    //         }
    //         ul{
    //             overflow: hidden;
    //             li{
    //                 float: left;
    //                 width: 33.33%;
    //                 height: rem(90px);
    //                 line-height: rem(90px);
    //                 padding-left: rem(30px);
    //                 background: #fff;
    //                 border-bottom: 2px solid #f3f4f5;
    //                 border-right: 2px solid #f3f4f5;
    //                 display: flex;
    //                 align-items: center;
    //                 >img{
    //                     display: block;
    //                     width: rem(30px);
    //                     height: rem(30px);
    //                     margin-right: rem(14px);
    //                 }
    //                 >p{
    //                     width: 0%;
    //                     flex: 1;
    //                     overflow: hidden;
    //                     text-overflow: ellipsis;
    //                     white-space: nowrap;
    //                     font-size: rem(28px);
    //                     color: #333;
    //                     line-height: rem(30px);
    //                 }
    //                 &:nth-child(n+3){
    //                     border-right: 0;
    //                 }
    //                 // &:nth-last-child(1),
    //                 // &:nth-last-child(2),
    //                 // &:nth-last-child(3){
    //                 //     border-bottom: 0;
    //                 // }
    //             }
    //         }
    //     }
    // }
}
</style>
